const footerLinks = [
  { href: "#ranking", label: "排行榜" },
  { href: "#category", label: "分类大全" },
  { href: "#completed", label: "完结漫画" },
  { href: "#fansub", label: "汉化专区" },
  { href: "#picks", label: "编辑精选" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">动漫之家漫画网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-background-400">
              聚合排行榜、完结漫画、分类大全与独家汉化组内容的漫画资讯门户，
              帮助每一位读者快速找到值得熬夜追完的佳作。
            </p>
          </div>

          <nav aria-label="页脚导航">
            <h4 className="mb-4 text-sm font-bold text-background-50">快速浏览</h4>
            <ul className="flex flex-col gap-2.5">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-background-400 transition-colors hover:text-accent-400">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h4 className="mb-4 text-sm font-bold text-background-50">联系我们</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>service@dmzjweb.example
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>周一至周日 9:00 – 21:00
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-translate-2"></i>官方合作汉化组入驻
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 sm:flex-row">
          <p className="text-xs text-background-500">
            © 2026 动漫之家漫画网 版权所有 · 专注高分漫画与完结佳作推荐
          </p>
          <p className="text-xs text-background-500">
            每日更新 · 独家汉化 · 分类大全
          </p>
        </div>
      </div>
    </footer>
  );
}